import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import LayoutWrapper from '@/components/LayoutWrapper';
import LoginPage from '@/pages/Login';
import DashboardPage from '@/pages/Dashboard';
import IndustryListPage from '@/pages/industries/List';
import IndustryFormPage from '@/pages/industries/Form';

// 16 个通用 CRUD 页
import IndustriesGenericPage from '@/pages/generic/Industries';
import FaqPage from '@/pages/generic/Faq';
import ProductsPage from '@/pages/generic/Products';
import OrdersPage from '@/pages/generic/Orders';
import PaymentsPage from '@/pages/generic/Payments';
import NotificationsPage from '@/pages/generic/Notifications';
import CouponsPage from '@/pages/generic/Coupons';
import ScoringPage from '@/pages/generic/Scoring';
import ScoringDisputesPage from '@/pages/generic/ScoringDisputes';
import ProctorPage from '@/pages/generic/Proctor';
import LoginHistoryPage from '@/pages/generic/LoginHistory';
import UsersPage from '@/pages/generic/Users';
import ExamParticipantsPage from '@/pages/generic/ExamParticipants';
import QuestionsPage from '@/pages/generic/Questions';
import QuestionGroupsPage from '@/pages/generic/QuestionGroups';
import ExamPapersPage from '@/pages/generic/ExamPapers';
import ExamSessionsPage from '@/pages/generic/ExamSessions';

import { useAuthStore } from '@/stores/auth';

function RequireAuth() {
  const token = useAuthStore((s) => s.accessToken);
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <LayoutWrapper />,
        children: [
          { path: '/', element: <Navigate to="/dashboard" replace /> },
          { path: '/dashboard', element: <DashboardPage /> },

          // 行业管理保留旧的定制 List/Form (含多语言 Tab), generic 版本同时挂在 /industries-generic 供对比
          { path: '/industries', element: <IndustryListPage /> },
          { path: '/industries/new', element: <IndustryFormPage /> },
          { path: '/industries/:id/edit', element: <IndustryFormPage /> },
          { path: '/industries-generic', element: <IndustriesGenericPage /> },

          // 16 个通用 CRUD 页
          { path: '/faq', element: <FaqPage /> },
          { path: '/products', element: <ProductsPage /> },
          { path: '/orders', element: <OrdersPage /> },
          { path: '/payments', element: <PaymentsPage /> },
          { path: '/notifications', element: <NotificationsPage /> },
          { path: '/coupons', element: <CouponsPage /> },
          { path: '/scoring', element: <ScoringPage /> },
          { path: '/scoring-disputes', element: <ScoringDisputesPage /> },
          { path: '/proctor', element: <ProctorPage /> },
          { path: '/login-history', element: <LoginHistoryPage /> },
          { path: '/users', element: <UsersPage /> },
          { path: '/exam-participants', element: <ExamParticipantsPage /> },
          { path: '/questions', element: <QuestionsPage /> },
          { path: '/question-groups', element: <QuestionGroupsPage /> },
          { path: '/exam-papers', element: <ExamPapersPage /> },
          { path: '/exam-sessions', element: <ExamSessionsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]);
